// DO NOT set the `name` and `ticker` properties manually
// Instead use one of the get token metadata scripts https://github.com/ExodusMovement/exodus-core/tree/master/packages/assets-base#get-token-metadata

export default [
  {
    name: '4zmm_solanadevnet_1318d07d',
    displayName: 'USDC',
    decimals: 6,
    ticker: '4ZMMsolanadevnet1318D07D',
    displayTicker: 'USDC',
    mintAddress: '4zMMC9srt5Ri5X14GAgXhaHii3GnPAEERYPJgZJDncDU',
    primaryColor: '#3e90e8',
    gradientColors: ['#eaeaea', '#fff'],
    gradientCoords: {
      x1: '19.031%',
      y1: '-66.682%',
      x2: '123.324%',
      y2: '91.487%',
    },
  },
]
